import {Divider, Typography} from "antd";
import {InfoCircleFilled} from "@ant-design/icons";
import UploadDropzone from "./UploadDropzone";

// Empty-state block shared by /app/run and /app/results: an "Upload Project"
// heading + divider over the upload drop area (mirroring the /app/load-project
// card), with a small inline info icon + message sitting side by side beneath.
export default function UploadEmptyState({message, showDropzone = true}) {
    return (
        <div style={{backgroundColor: 'white', padding: 24}}>
            {showDropzone && (
                <>
                    <div style={{display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500, fontSize: 16}}>
                        Upload Project
                    </div>
                    <Divider style={{margin: '16px 0'}}/>
                    <UploadDropzone />
                </>
            )}
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 16}}>
                <InfoCircleFilled style={{fontSize: 18, color: '#1890ff'}} />
                <Typography.Text type={'secondary'}>{message}</Typography.Text>
            </div>
        </div>
    )
}
